/*
 *   File : custom-day-picker.js
 *   Author : https://evoqins.com
 *   Description : Day picker component (1–28 days)
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { Icon } from '../Icon';

//custom style
import style from "../../Style/Component/input.module.scss";
import { OverLay } from '../Others';

const CustomDayPicker = (props) => {

    const days = Array.from({ length: 28 }, (_, i) => i + 1); // Days 1–28

    const [selectedDay, setSelectedDay] = useState(null);
    const [toggle, setToggle] = useState(false);

    useEffect(() => {
        if (props.selected) {
            setSelectedDay(props.selected);
        } else {
            setSelectedDay(null);
        }
    }, [props.selected]);

    const handleDayClick = (day) => {
        setSelectedDay(day);
        setToggle(false);
        props.handleSelect(day);
    };

    const _handleClear = () => {
        setSelectedDay(null);
        props.handleClear && props.handleClear();
    };

    return (
        <div className={`${props.wrapperClass} position-relative`} >
            {props.label && (
                <label className={`${props.labelStyle} d-flex e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px padding-4px-bottom`}>
                    {props.label}
                    {props.required && <span className='e-text-carmine-pink'>*</span>}
                </label>
            )}

            {/* Input box */}
            <div
                className={`${toggle ? 'e-border-0-5px-blue-violet' : props.error ? 'e-border-0-5px-carmine-pink' : 'e-border-1px-light-purple'}  
                    e-bg-white padding-10px-tb padding-10px-lr d-flex justify-content-between border-radius-8 cursor-pointer`}
                onClick={() => setToggle(prev => !prev)}
                style={{ width: "152px" }}     >
                {selectedDay !== null ? (
                    <>
                        <p className='mb-0 e-primary-font e-font-14 e-text-chinese-black e-font-weight-500 line-height-18px'>
                            Day {selectedDay}
                        </p>
                        <div onClick={(event) => event.stopPropagation()}>
                            <Icon
                                icon="close"
                                className='cursor-pointer d-flex position-relative'
                                size="16px"
                                onClick={_handleClear}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <p className='mb-0 e-text-davys-grey-light  e-primary-font e-font-14 e-font-weight-500 line-height-18px'>
                            {props.placeholder}
                        </p>
                        <img src={require("../../Assets/Image/Others/calendar.svg").default} />
                    </>
                )}
            </div>

            {/* Error Message */}
            {props.error && (
                <p className={`${style.e_error_message} position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                    {props.error}
                </p>
            )}

            {/* Day dropdown */}
            {toggle && (
                <>
                    <OverLay isOpen={toggle} onClose={() => setToggle(prev => !prev)} />
                    <div
                        className='position-absolute e-bg-white top-60px p-3 border-radius-16 z-index-99'
                        style={{
                            // width: '280px',
                            border: '1px solid #ccc',
                            padding: '16px',
                            borderRadius: '8px'
                        }}
                    >
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '8px' }}>
                            {days.map((day) => (
                                <div
                                    key={day}
                                    onClick={() => handleDayClick(day)}
                                    className={`${day === selectedDay
                                        ? "e-bg-blue-violet e-text-white"
                                        : "e-bg-magnolia e-text-chinese-black"
                                        } p-2 text-center border-radius-4 cursor-pointer e-primary-font e-font-14 e-font-weight-500 line-height-16px`}
                                >
                                    {day}
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default CustomDayPicker;
